import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Usuario } from "@shared/Entities/Usuario/usuario.entity";

import { CanalesRepository } from "../Repositories/canales.repository";
import { NewUser, NewUserFiduciary } from "../Types/new-user";

@Injectable()
export class CanalesService {
  constructor(private readonly canalesRepository: CanalesRepository) {}

  public createNewUserFiduciary({ isUserCanales, isUserAdmin, ...newUser }: NewUser): Observable<Usuario> {
    return this.canalesRepository.createNewUserFiduciary(newUser, isUserCanales, isUserAdmin);
  }

  public createNewUser({ isUserCanales, isUserAdmin, ...newUser }: NewUser): Observable<Usuario> {
    return this.canalesRepository.createNewUser(newUser, isUserCanales, isUserAdmin);
  }

  public editUserFiduciary(newUser: NewUser, id: number): Observable<Usuario> {
    return this.canalesRepository.editUserFiduciary(newUser, id);
  }

  public editUser(newUser: NewUser, id: number): Observable<Usuario> {
    return this.canalesRepository.editUser(newUser, id);
  }

  public lockUser(userGuid: string): Observable<void> {
    return this.canalesRepository.lockUser(userGuid);
  }

  public unLockUser(userGuid: string): Observable<void> {
    return this.canalesRepository.unLockUser(userGuid);
  }

  public getUser(userGuid: string): Observable<Usuario> {
    return this.canalesRepository.getUser(userGuid);
  }

  public getUserFiduciary(userGuid: string): Observable<Usuario> {
    return this.canalesRepository.getUserFiduciary(userGuid);
  }

  public mapFromUserToNewUser(user: Usuario): NewUser {
    const roles = user.usuarioRole.map(({ role }) => {
      return role;
    });
    return {
      roles,
      name: user.metadata.nombres,
      lastName: user.metadata.apellidos,
      email: user.metadata.email,
      profile: user.perfil,
      birthDate: new Date(user.cumpleanos),
      identification: user.metadata.numeroIdentificacion,
      identificationProfile: user.metadata.identificacionPerfil,
      province: {
        id: user.provinciaId,
        nombre: user.provincia as any,
      },
      telephone: user.metadata.telephone,
      intermediaryCode: user.metadata.codigoIntermediario,
      userCode: user.metadata.userCode,
      clientCode: user.metadata.clientCode,
      clientCodeUnit: user.metadata.codigoClienteUnit,
      intermediaryCodeUnit: user.metadata.codigoIntermediarioUnit,
      officeCode: user.metadata.sucursal,
      healthProviderCode: user.metadata.codigoPrestador,
      company: user.metadata.empresa,
      identificationType: Number(user.metadata.tipoIdentificacionId),
      empresaUnitId: user.metadata.empresaUnitId,
    };
  }

  public mapFromUserToNewUserFiduciary(user: Usuario): NewUserFiduciary {
    const roles = user.usuarioRole.map(({ role }) => role);
    const permisosRole = user.permisosRole || [];
    return {
      roles,
      id: user.id,
      name: user.metadata.nombres,
      lastName: user.metadata.apellidos,
      email: user.metadata.email,
      profile: user.perfil,
      birthDate: new Date(user.cumpleanos),
      identification: user.metadata.numeroIdentificacion,
      identificationProfile: user.metadata.identificacionPerfil,
      province: {
        id: user.provinciaId,
        nombre: user.provincia as any,
      },
      telephone: user.metadata.telephone,
      userCode: user.metadata.userCode,
      company: user.metadata.empresa,
      identificationType: Number(user.metadata.tipoIdentificacionId),
      escrows: user.escrows,
      idAdminSelected: user.idAdminSelected,
      permisosRole,
    };
  }
}
